import { PureComponent } from 'preact-compat'
import { ContentType } from '@insided/shared/utils/contentType'
import CategorySelector from '@insided/control/uikit/CategorySelector'
import { changeCategory } from '../services/topicService'
import { ParentCategory } from '../interfaces'

// eslint-disable-next-line import/no-internal-modules
import InputUnit from '@insided/deprecated-preact-components/design-system-components/input-unit'

interface ForumProps {
  onCategoryChanged: (categoryId: number) => void
  setIsLoading: (isLoading: boolean) => void
  categories: ParentCategory[]
  categoryId: number
  contentType: ContentType
  privateId: number
  onShowAlert: (type: 'success' | 'error', message?: string) => void
}
export default class Forum extends PureComponent<ForumProps> {
  constructor(props: ForumProps) {
    super(props)
    this.onChangeCategory = this.onChangeCategory.bind(this)
  }

  async onChangeCategory(categoryId: number) {
    const { contentType, privateId, onCategoryChanged, onShowAlert, setIsLoading } = this.props
    setIsLoading(true)
    onCategoryChanged(categoryId)
    try {
      await changeCategory(privateId, contentType, categoryId)
    } catch (e) {
      onShowAlert('error')
    } finally {
      setIsLoading(false)
    }
  }

  render() {
    const { categories, categoryId } = this.props
    return (
      <div className='topic-info__details-item'>
        <label>Forum</label>
        <InputUnit>
          <CategorySelector categories={categories} categoryId={categoryId} onUpdate={this.onChangeCategory} />
        </InputUnit>
      </div>
    )
  }
}
